import schema from './schema';

import { addMaskCellphone, addMaskPhone, cloneObject } from '../../../../utils';

function translate(data) {
    const clonedSchema = cloneObject(schema);

    if (!data) return clonedSchema;

    clonedSchema.costCenterCode.value = data.codigoCentroCusto;
    clonedSchema.costCenterName.value = data.nomeCentroCusto;
    clonedSchema.costCenterInitials.value = data.sigla;
    clonedSchema.costCenterResponsible.value = data.nomeResponsavel;
    clonedSchema.ramal.value = data.ramal;
    clonedSchema.cep.value = data.cep;
    clonedSchema.cep.unmaskedValue = data.cep;
    clonedSchema.address.value = data.endereco;
    clonedSchema.addressNumber.value = data.numero;
    clonedSchema.complement.value = data.complemento;
    clonedSchema.hood.value = data.bairro;
    clonedSchema.uf.value = data.uf;
    clonedSchema.city.value = data.codigoCidade;

    clonedSchema.cellphone.value = data.dddCelular && addMaskCellphone(`${data.dddCelular}${data.numeroCelular}`);
    clonedSchema.cellphone.unmaskedValue = data.dddCelular && `(${data.dddCelular}) ${data.numeroCelular}`;

    clonedSchema.comercialPhone.value = data.dddTelefone && addMaskPhone(`${data.dddTelefone}${data.numeroTelefone}`);
    clonedSchema.comercialPhone.unmaskedValue = data.dddTelefone && `(${data.dddTelefone}) ${data.numeroTelefone}`;

    clonedSchema.email.value = data.email;

    return clonedSchema;
}

export default translate;
